import http from "@/http-common";

class NewsinfoDataService {
  getNewsMailUserList(data: any): Promise<any> {
    return http.api.post("/getNewsMailUserList/", data);
  }
  addNewsMailUser(data: any): Promise<any> {
    return http.api.post("/addNewsMailUser/", data);
  }
  deleteNewsMailUser(data: any): Promise<any> {
    return http.api.post("/deleteNewsMailUser/", data);
  }
}
export default new NewsinfoDataService();
